// extracted by mini-css-extract-plugin
export default {"main":"AdminGoals_main__Ex4Fr","heads":"AdminGoals_heads__3aCNc"};